export default __webpack_public_path__ + "static/media/army_schematic_frame.4eaa6e4f.png";